type Platform = "github" | "linkedin" | "email";

export type SocialLink = Record<Platform, { url: string; label: string }>;

export const socialLinks: SocialLink = {
  github: {
    url: "https://github.com/khang-874",
    label: "GitHub",
  },
  linkedin: {
    url: "https://www.linkedin.com/in/khangtran874",
    label: "LinkedIn",
  },
  email: {
    url: "mailto:khang07087@gmail.com",
    label: "Email",
  },
};

export const email = "khang07087@gmail.com";
